// Create a custom event name
export const SESSION_EXPIRED_EVENT = 'session-expired';

// Function to trigger the event
export const triggerSessionExpired = () => {
  const event = new Event(SESSION_EXPIRED_EVENT);
  window.dispatchEvent(event);
};